import cartSlice from '@reducers/cart';
import useTableDetail from '@services/table/hooks/useTableDetail';
import { AppDispatch, RootState } from '@stores/index';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

function useGetTableName() {
  const router = useRouter();
  const { table } = router.query;
  const dispatch: AppDispatch = useDispatch();
  const { tableName } = useSelector((state: RootState) => state.cart);

  const { data, isLoading, isError, isFetching } = useTableDetail(table?.toString() || '', {
    enabled: !!table,
  });

  useEffect(() => {
    // TODO: here we should remove table from redux and used react query
    if (data?.data && !isLoading && !isError && !isFetching) {
      dispatch(cartSlice.actions.setTableNumber(data?.data?.id?.toString()));
      dispatch(cartSlice.actions.setTableName(data?.data?.name?.toString()));
    } else {
      dispatch(cartSlice.actions.setTableNumber(undefined));
      dispatch(cartSlice.actions.setTableName(undefined));
    }
  }, [data?.data, dispatch, isError, isLoading, table, isFetching]);

  return {
    tableName: tableName || table?.toString(),
    tableId: table?.toString(),
    loading: isLoading || isFetching,
  };
}

export default useGetTableName;
